"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextInput = exports.StyledTextInputControl = exports.MIN_WIDTH_TEXT_INPUT = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const InputBox_1 = require("../helpers/InputBox");
const InputControl_1 = require("../helpers/InputControl");
exports.MIN_WIDTH_TEXT_INPUT = '30px';
exports.StyledTextInputControl = (0, styled_components_1.default)(InputControl_1.InputControl) `
    height: 100%; // remove scroll inside input

    ${({ readOnly, theme }) => readOnly &&
    (0, styled_components_1.css) `
            background-color: ${theme.colorBackgroundDisabled};
            border: ${theme.colorBorderMain};
        `}
`;
exports.StyledTextInput = (0, styled_components_1.default)(InputBox_1.InputBox) `
    min-width: ${exports.MIN_WIDTH_TEXT_INPUT};
`;
//# sourceMappingURL=TextInput.styles.js.map